import React from "react";

import { Advertisement } from "@/common/Outro/Advertisement";
import { GlobalContextProps } from "@/contexts/GlobalContext";
import {
  InteractionLayout,
  InteractionOutro,
  OutroType,
} from "@/service/Model";

import { OutroOverlay } from "./index";
import { Outlink } from "./Outlink";
import { Question } from "./Question";
import { RegistrationForm } from "./RegistrationForm";

export function renderOutro(
  outro: InteractionOutro,
  context: { globals: GlobalContextProps },
  onClose: () => void,
  onSubmitEnd?: (status?: string) => void, // voting only
  hasScrollbar = false
): React.JSX.Element {
  const {
    globals: { tealiumConfig, response },
  } = context;
  const { interaction } = response!;
  const { outroType } = outro;
  const lightLayout = interaction.layout === InteractionLayout.Light;
  const isPremiumUser = !!tealiumConfig?.is_premium_user;

  const renderContent = (): React.JSX.Element => {
    if (outroType === OutroType.Advertising) {
      return <Advertisement outro={outro} />;
    } else if (outroType === OutroType.Outlink) {
      return <Outlink outro={outro} onClose={onClose} />;
    } else if (outroType === OutroType.RegistrationForm) {
      return (
        <RegistrationForm
          lightLayout={lightLayout}
          outro={outro}
          onClose={onClose}
          onSubmitEnd={onSubmitEnd}
        />
      );
    } else if (outroType === OutroType.Request) {
      return <Question outro={outro} onClose={onClose} />;
    } else if (outroType === OutroType.RequestOrAdvertising) {
      // decision logic: https://as-wiki.axelspringer.de/pages/viewpage.action?pageId=241896322
      if (isPremiumUser) {
        return <Question outro={outro} onClose={onClose} />;
      }
      const randomizer = Math.floor(Math.random() * 100);
      if (randomizer < 61) {
        return <Advertisement outro={outro} />;
      } else {
        return <Question outro={outro} onClose={onClose} />;
      }
    } else {
      return <></>;
    }
  };

  return (
    <OutroOverlay
      hasTopPadding={outro.outroType !== OutroType.RegistrationForm}
      onClose={onClose}
      lightLayout={lightLayout}
      hasScrollbar={hasScrollbar}
    >
      {renderContent()}
    </OutroOverlay>
  );
}
